<lgv-dialog-wrapper [titleText]="data.user ? 'admin_dialogs_user_edituser' : 'admin_dialogs_user_adduser'">
  <lgv-profile-image-picker
    (fileChanged)="onFileSelected($event)"
    [imageURL]="data.user?.imageID | getDocument | async"
    style="justify-content: center; margin-bottom: 32px"
  ></lgv-profile-image-picker>

  <form [formGroup]="formGroup" class="form" (ngSubmit)="submit()">
    <mat-form-field>
      <mat-label translate>admin_dialogs_user_firstname</mat-label>
      <input matInput formControlName="firstname" />
      @if (this.getField('firstname').invalid) {
        <mat-error>
          {{ 'admin_dialogs_user_required' | translate }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label translate>admin_dialogs_user_lastname</mat-label>
      <input matInput formControlName="lastname" />
      @if (this.getField('lastname').invalid) {
        <mat-error> {{ 'admin_dialogs_user_required' | translate }} </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label translate>admin_dialogs_user_role</mat-label>
      @if (data.user?.scopes !== 'cms') {
        <mat-select formControlName="scope">
          @for (item of roles; track item) {
            <mat-option [value]="item">
              {{ item }}
            </mat-option>
          }
        </mat-select>
      }
      @if (data.user?.scopes === 'cms') {
        <mat-select formControlName="scope">
          <mat-option value="cms"> cms </mat-option>
        </mat-select>
      }
      @if (this.getField('scope').hasError('required')) {
        <mat-error>
          {{ 'admin_dialogs_user_required' | translate }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label translate>admin_dialogs_user_organisation</mat-label>
      <mat-select formControlName="organisation">
        <mat-option>None</mat-option>
        @for (item of organisations; track item) {
          <mat-option [value]="item.id">
            {{ item.name }}
          </mat-option>
        }
      </mat-select>
      @if (this.getField('scope').hasError('required')) {
        <mat-error>
          {{ 'admin_dialogs_user_required' | translate }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label translate>admin_dialogs_user_email</mat-label>
      <input matInput formControlName="email" />
      @if (this.getField('email').invalid) {
        <mat-error> {{ 'admin_dialogs_user_required' | translate }} </mat-error>
      }
    </mat-form-field>

    <lgv-button-container
      buttonLeftText="admin_dialogs_user_buttonleft"
      buttonRightText="admin_dialogs_user_buttonright"
      buttonRightType="submit"
      [disabled]="isLoading"
      (onLeftClicked)="close()"
    >
    </lgv-button-container>
  </form>
</lgv-dialog-wrapper>
